import { lighten } from 'polished';
import styled from 'styled-components';

// fundo e cor do texto de cada card vêm de util/coresTema (tons da cor do cliente)
export const Container = styled.div`
  padding: 2px 10px 0px 15px;

  h1 {
    font-family: ${({ theme }) => theme.fonts.title};
    color: ${({ theme }) => theme.colors.subtitle};
  }

  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  .container-grade {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
    gap: 12px;
    padding-bottom: 10px;
  }

  /* button com display block centraliza o conteúdo na vertical, igual ao modelo */
  .container-item {
    position: relative;
    overflow: hidden;
    display: block;
    width: 100%;
    height: 100px;
    padding: 14px 16px;
    margin: 0;
    border: none;
    border-radius: 16px;
    text-align: left;
    font: inherit;

    :hover {
      cursor: pointer;
      filter: brightness(1.06);
    }

    :focus {
      outline: none;
    }

    :focus-visible {
      outline: 3px solid #1a1a1a;
      outline-offset: 2px;
    }

    .nome-categoria {
      position: relative;
      z-index: 1;
      max-width: 96px;

      font-size: 15px;
      line-height: 1.25;
      font-family: ${({ theme }) => theme.fonts.fontSubttitle};

      overflow-wrap: anywhere;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .foto-categoria {
      position: absolute;
      right: -8px;
      bottom: -10px;
      width: 82px;
      height: 82px;
      overflow: hidden;
      border-radius: 50%;
      border: 3px solid rgba(255, 255, 255, 0.9);
      background: #ffffff;

      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

  @media screen and (max-width: 800px) {
    padding: 2px 5px 2px 5px;

    h1 {
      margin-left: 6px;
    }

    .container-grade {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .container-item {
      height: 92px;

      .foto-categoria {
        width: 76px;
        height: 76px;
      }
    }
  }
`;

export const BarraVoltar = styled.div`
  background: ${({ theme }) => theme.colors.primary};
  margin: 2px 12px 2px 17px;
  padding: 2px 15px 2px 10px;
  border-radius: ${({ theme }) => theme.borderRadius};
  color: ${({ theme }) => theme.colors.backgroundCard};

  display: flex;
  align-items: center;

  :hover {
    cursor: pointer;
    background: ${props => lighten(0.05, props.theme.colors.primary)};
  }

  i {
    font-size: 25px;
    margin-right: 10px;
  }

  h1 {
    flex: 1;
    font-size: 18px;
    font-family: 'PoppinsBold';
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  @media screen and (max-width: 800px) {
    margin: 2px 4px 2px 7px;
  }
`;
